import GiftOrdering from '../modules/checkoutModule/components/GiftOrderingPage';

export default GiftOrdering;
